// extracted by css-extract-rspack-plugin
export default {"dotsWrapper":"_bb66d060"};